// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9ca9bdea","703":"4c886f85","787":"35b405ff"}[chunkId] + ".chunk.js";
};